var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45817 10.541H5.95817C5.8047 10.541 5.67609 10.4895 5.57234 10.3864C5.46845 10.2834 5.4165 10.1557 5.4165 10.0035C5.4165 9.85115 5.46845 9.72213 5.57234 9.61643C5.67609 9.5106 5.8047 9.45768 5.95817 9.45768H9.45817V5.95768C9.45817 5.80421 9.5097 5.6756 9.61275 5.57185C9.71581 5.46796 9.84345 5.41602 9.99567 5.41602C10.148 5.41602 10.2771 5.46796 10.3828 5.57185C10.4886 5.6756 10.5415 5.80421 10.5415 5.95768V9.45768H14.0415C14.195 9.45768 14.3236 9.50921 14.4273 9.61227C14.5312 9.71532 14.5832 9.84296 14.5832 9.99518C14.5832 10.1475 14.5312 10.2766 14.4273 10.3823C14.3236 10.4881 14.195 10.541 14.0415 10.541H10.5415V14.041C10.5415 14.1945 10.49 14.3231 10.3869 14.4268C10.2839 14.5307 10.1562 14.5827 10.004 14.5827C9.85164 14.5827 9.72262 14.5307 9.61692 14.4268C9.51109 14.3231 9.45817 14.1945 9.45817 14.041V10.541Z",
    fill: "#101014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.6fe74597905b99122452bad8ea9123d7.svg";
export { ForwardRef as ReactComponent };